import { render, staticRenderFns } from "./ProductAdminView.vue?vue&type=template&id=b6b7de52&scoped=true"
import script from "./ProductAdminView.vue?vue&type=script&lang=js"
export * from "./ProductAdminView.vue?vue&type=script&lang=js"
import style0 from "./ProductAdminView.vue?vue&type=style&index=0&id=b6b7de52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b7de52",
  null
  
)

export default component.exports